import "https://player.vimeo.com/api/player.js";
class VimeoList extends HTMLElement {
  constructor() {
    super();
    this.videos = this.children;
    this.index = 0;
    this.size = this.videos.length;

    this.mediaQuery = window.matchMedia("(min-width: 1100px)").matches;

    if (this.mediaQuery) {
      this.renderDesktop();
    } else {
      this.renderMobile();
    }
  }

  renderDesktop() {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "200px", // No margin around the root
      threshold: 0, // Trigger when 10% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.renderVideo([...this.videos][this.index].dataset.id);
        }
      });
    }, options);
    observer.observe(this);
  }

  renderVideo(id) {
    let player = new Vimeo.Player(id, {
      id: id,
      autoplay: false,
      muted: true,
      background: false,
    });

    player.play();
    this.index++;

    player.on("ended", () => {
      player.destroy();
      if (this.index === this.size) {
        this.index = 0;
      }
      this.renderVideo([...this.videos][this.index].dataset.id);
    });
  }

  renderMobile() {
    this.initVideoCount = 0;
    this.videoCount = this.querySelectorAll(".products-on-videos__item").length;
    this.vimeoVideoPlayers = {};
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "300px 0px", // No margin around the root
      threshold: 0.3, // Trigger when 10% of the element is visible
    };
    [...this.videos].forEach((video) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.initVideoCount == this.videoCount) {
              const videoPlayer =
                this.vimeoVideoPlayers[entry.target.dataset.id];
              console.log("Start playing for " + entry.target.dataset.id);
              videoPlayer.play();
            } else {
              let currentVideoPlayer = this.vimeoVideoPlayers[video.dataset.id];
              if (currentVideoPlayer) {
                return;
              }
              currentVideoPlayer = new Vimeo.Player(video.dataset.id, {
                id: video.dataset.id,
                autoplay: false,
                muted: true,
                background: false,
              });

              this.vimeoVideoPlayers[video.dataset.id] = currentVideoPlayer;

              currentVideoPlayer.on("loaded", () => {
                this.initVideoCount = this.initVideoCount + 1;
                this.scrollLeft = 0;
                this.parentElement.scrollLeft = 0;
                const firstVideo = this.querySelector(
                  ".products-on-videos__item"
                ).dataset.id;
                const firstVideoPlayer = this.vimeoVideoPlayers[firstVideo];
                if(firstVideoPlayer) {
                  firstVideoPlayer.play();
                }
              });
            }
          }
        });
      }, options);
      observer.observe(video);
    });
  }
}

customElements.define("vimeo-list", VimeoList);

class SmallSlider extends HTMLElement {
  constructor() {
    super();

    this.scrollingList = this.querySelector(".products-on-videos__products");
    this.getButtons = this.parentElement.querySelectorAll(
      ".products-on-videos__button"
    );

    this.scrollingWidth = this.scrollingList.scrollWidth;
    this.size =
      this.scrollingList.querySelectorAll("product-card-small").length;
    this.slideWidth =
      this.scrollingList.querySelector("product-card-small").clientWidth;
    this.scrollWrapper = this.parentElement.querySelector(
      ".products-on-videos__slider-wrapper"
    );

    this.currentIndex = 0;

    this.scrollingList.addEventListener("scroll", () => {
      this.currentIndex = Math.round(
        this.scrollingList.scrollLeft / (this.scrollingWidth / this.size)
      );
      this.visibilityNav(this.currentIndex, this.size);
    });
    this.navigateButtons();

    this.scrollWrapper.addEventListener("touchstart", (e) => {
      this.touchStart = e.touches[0].clientX;
    });

    this.scrollWrapper.addEventListener("touchend", (e) => {
      const touchDiff = e.changedTouches[0].clientX - this.touchStart;
      if (Math.abs(touchDiff) < 50) {
        return;
      }
      const changeIndexFactor = touchDiff > 0 ? -1 : 1;
      console.log(changeIndexFactor);
      this.currentIndex = this.currentIndex + changeIndexFactor;
      let scrollPath = Math.floor(this.scrollingWidth / this.size);
      console.log(scrollPath * changeIndexFactor);
      this.scrollingList.scrollLeft += scrollPath;
    });
  }

  navigateButtons() {
    let scrollPath = Math.floor(this.scrollingWidth / this.size);
    this.getButtons?.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.getAttribute("data-switch-action") == "next") {
          console.log("CLICKOS");
          this.scrollingList.scrollLeft += scrollPath;
        }
        if (btn.getAttribute("data-switch-action") == "prev") {
          this.scrollingList.scrollLeft -= scrollPath;
        }
      });
    });
  }

  visibilityNav(currentIndex, size) {
    let prev = this.getButtons[0];
    let next = this.getButtons[1];

    currentIndex === 0
      ? prev.setAttribute("data-active", "false")
      : prev.setAttribute("data-active", "true");

    currentIndex === size - 1
      ? next.setAttribute("data-active", "false")
      : next.setAttribute("data-active", "true");
  }
}

customElements.define("small-slider", SmallSlider);
